import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "av-container" }
const _hoisted_2 = { class: "app-details" }
const _hoisted_3 = { class: "app-grp" }
const _hoisted_4 = { class: "app-name" }
const _hoisted_5 = { class: "app-detail-info" }
const _hoisted_6 = { class: "app-detail-info" }
const _hoisted_7 = {
  key: 0,
  class: "app-cancel"
}
const _hoisted_8 = { class: "app-status" }
const _hoisted_9 = { class: "app-further-details" }
const _hoisted_10 = { class: "app-stat-desc" }
const _hoisted_11 = { class: "circle" }
const _hoisted_12 = { class: "app-st" }

import { computed, onMounted } from "vue";
import { Application } from "@/models/application";
import useFormatter from "@/use/formatter";
import router from "../router";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import CancellationModal from "@/components/modals/CancellationModal.vue";
import { ApplicationStatusTypeIds, ProductIds } from "@/config/constants";

interface Props {
  application: Application;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationView',
  props: {
    application: {}
  },
  emits: ["applicationCancelled"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const { formattedDateFormat } = useFormatter();
const route = useRoute();
const store = useStore();
const cancelApplication = computed(() => store.getters["modal/cancellationModalActive"]);
const applicationStatusId = computed(() => props.application.applicationStatusId);

const showCancellationLink = computed(() => {
  return (
    applicationStatusId.value === ApplicationStatusTypeIds.NOT_SUBMITTED ||
    applicationStatusId.value === ApplicationStatusTypeIds.EVALUATION ||
    applicationStatusId.value === ApplicationStatusTypeIds.SUBMITTED_AND_PROCESSING ||
    applicationStatusId.value === ApplicationStatusTypeIds.RIGHT_TO_CANCEL
  );
});

function viewApplication(referenceId: string | undefined) {
  const query = route.query as any;
  // redirect to application page
  router.push({ path: `/applications/${referenceId}`, query });
}

function openCancellationModal() {
  store.dispatch("modal/openCancellationModal", props.application.referenceId);
}

onMounted(async () => {
  await store.dispatch("lookupsModule/getLookups");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.application.applicationTypeName), 1),
        _createElementVNode("div", _hoisted_5, "Application ID: " + _toDisplayString(__props.application.referenceId), 1),
        _createElementVNode("div", _hoisted_6, " Started on " + _toDisplayString(_unref(formattedDateFormat)(__props.application.created, "MM/DD/YYYY")) + " | Expires on " + _toDisplayString(_unref(formattedDateFormat)(__props.application.expires, "MM/DD/YYYY")), 1)
      ]),
      (showCancellationLink.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("a", { onClick: openCancellationModal }, "Cancel Application")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[2] || (_cache[2] = _createElementVNode("div", null, "Application Status", -1)),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, _toDisplayString(__props.application.applicationStatusId), 1),
          _createElementVNode("div", _hoisted_12, _toDisplayString(__props.application.applicationStatusName), 1)
        ]),
        _createElementVNode("input", {
          type: "button",
          class: "app-view",
          value: "View Application",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (viewApplication(__props.application.referenceId)))
        })
      ])
    ]),
    (cancelApplication.value)
      ? (_openBlock(), _createBlock(CancellationModal, {
          key: 0,
          application: __props.application,
          onCancelApplication: _cache[1] || (_cache[1] = ($event: any) => (emit('applicationCancelled')))
        }, null, 8, ["application"]))
      : _createCommentVNode("", true)
  ]))
}
}

})